export class Pagination {
  constructor(
    public readonly offset: number,
    public readonly limit: number,
  ) {}
}
